import { CircularProgress, Typography, Box, keyframes } from "@mui/material"

// Create a pulse animation
const pulse = keyframes`
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    opacity: 0.6;
  }
`

const LoadingSpinner = ({ size = 40, message = "Loading...", showMessage = true }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: 4,
      }}
    >
      <CircularProgress
        size={size}
        thickness={4}
        sx={{
          mb: 2,
          color: "primary.main",
          animation: `${pulse} 1.5s ease-in-out infinite`,
        }}
      />
      {showMessage && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            mt: 1,
            animation: `${pulse} 1.5s ease-in-out infinite`,
            fontWeight: 500,
          }}
        >
          {message}
        </Typography>
      )}
    </Box>
  )
}

export default LoadingSpinner

